export default __webpack_public_path__ + "static/media/modal_x_close.84945f05.svg";